module.exports = __webpack_public_path__ + "static/media/maleCuteCool.7b31758c.png";